module.exports = __webpack_public_path__ + "img/printer-black.0c8b4b4f.svg";